<template>
  <div
    class="Paragraphe"
    :class="jel_getClassObject(content)"
    v-html="jel_replaceTokens(content.richText)"
  ></div>
</template>

<script>
export default {
  name: 'Paragraphe',
  props: { content: { type: Object, required: true } },
};
</script>

<style lang="scss">
.Paragraphe ul li {
  margin-left: 1rem;
}
</style>
